import React, {Component} from 'react';
import {ROLES, withRoles} from '../Permissions';
import Typography from '@material-ui/core/Typography';
import ReviewTable from './ReviewTable';

class Reviews extends Component {
    render() {
        return (
            <div>
                <Typography variant="h3" gutterBottom>
                    Reviews
                </Typography>

                <ReviewTable/>
            </div>
        );
    }
}

export default (withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER])(Reviews));
